<div class="d-flex flex-row-reverse justify-content-center" [class.readonly]="readonly">
<fa-icon [icon]="faStar" [class.fs-6]="readonly" [class.rated]="rating >= 5" #newRating (click)="setRating(5)"></fa-icon>
<fa-icon [icon]="faStar" [class.fs-6]="readonly" [class.rated]="rating >= 4" #newRating (click)="setRating(4)"></fa-icon>
<fa-icon [icon]="faStar" [class.fs-6]="readonly" [class.rated]="rating >= 3" #newRating (click)="setRating(3)"></fa-icon>
<fa-icon [icon]="faStar" [class.fs-6]="readonly" [class.rated]="rating >= 2" #newRating (click)="setRating(2)"></fa-icon>
<fa-icon [icon]="faStar" [class.fs-6]="readonly" [class.rated]="rating >= 1" #newRating (click)="setRating(1)"></fa-icon>
</div>

<span class="fs-2 hide" [class.d-none]="readonly">{{rating}}</span>
<!-- [class.d-none]="readonly" - added because of visible only bussiness details
[class.fs-6]="readonly" - added because of visible only product / business cart -->